@if (isZendeskAvailable && !isFromLiveChatLink) {
    <div
        id="pt-zendesk-parent-div"
        [ngClass]="{ 'btn-message-container': !isContact, 'bonus-card-heading-2 option-font zendesk-contact-page': isContact }">
        @if (!isContact && zendeskData) {
            <button
                class="btn w-100 zendesk-live-chat"
                id="zendesk-chat-btn"
                type="button"
                [disabled]="AccountorIpBlocked || isZendeskDisabled"
                [ngClass]="[
                    enableAcquisitionEnhancements ? 'btn-tertiary btn-lg compressedMargin-lrg' : 'btn-chat btn-outline-chat',
                    classname ? classname : '',
                ]"
                (click)="livechatclick()">
                <span class="theme-chat"></span>
                {{ zendeskData?.content?.zendeskChat?.title }}
            </button>
        }
        @if (isContact) {
            <span class="heading">{{ liveChatText }}</span>
        }
        @if (!isContact && zendeskData && (AccountorIpBlocked || isZendeskDisabled)) {
            <span class="btn-message" id="account-blocked-zendesk">{{ zendeskData?.content?.zendeskChat?.text }}</span>
        }
        @if (isContact && zendeskData && (AccountorIpBlocked || isZendeskDisabled)) {
            <div class="btn-livechat-container">
                <span id="account-blocked-zendesk">{{ zendeskData?.content?.zendeskChat?.text }}</span>
            </div>
        }
    </div>
}

@if (isFromLiveChatLink) {
    <div>
        <div
            class="pc-txt text-center d-flex justify-content-center align-items-center live-chat-link font-14"
            id="pullchatLink"
            [ngClass]="{ 'bg-body-10': !darkModeService.isEnabled }">
            <div>
                <span>{{
                    isZendeskAvailable && !AccountorIpBlocked
                        ? liveChatText
                            ? liveChatText
                            : commonMessages['LiveChatText']
                        : commonMessages['LiveChatDisabledText']
                }}</span
                >&nbsp;
                @if (isZendeskAvailable && !AccountorIpBlocked) {
                    <a href="#" (click)="livechatclick()">{{ commonMessages['LiveChatLink'] }}</a
                    >&nbsp;
                }
                <span class="theme-chat"></span>
            </div>
        </div>
    </div>
}
